import { Reveal } from "@/components/Reveal";
import { Stars } from "@/components/Stars";

const defaults = [
  { name: "Alex R.", role: "Verified Customer", rating: 5, text: "One of the best investments I've made. Clear, actionable and worth every cent.", avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzI3NzY1OXww&ixlib=rb-4.1.0&q=85" },
  { name: "Sam T.", role: "Verified Customer", rating: 5, text: "Actually practical advice instead of fluff. Read it in a day and started immediately.", avatar: "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0fGVufDB8fHx8MTc4NzI3NzY1OXww&ixlib=rb-4.1.0&q=85" },
  { name: "Morgan L.", role: "Verified Customer", rating: 5, text: "Paid for itself in the first week. Wish I'd found this sooner.", avatar: "https://images.pexels.com/photos/29852852/pexels-photo-29852852.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

export const Testimonials = ({ reviews }) => {
  const list = reviews && reviews.length ? reviews : defaults;
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32" data-testid="testimonials-section">
      <Reveal>
        <p className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground">Reviews</p>
        <h2 className="mt-3 max-w-2xl font-display text-4xl tracking-tight sm:text-5xl">Loved by thousands who took action.</h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden border border-black/10 bg-black/10 md:grid-cols-3">
        {list.slice(0, 3).map((r, i) => (
          <Reveal key={i} delay={i * 0.08} className="bg-white">
            <div className="flex h-full flex-col p-8">
              <Stars n={r.rating || 5} />
              <p className="mt-5 flex-1 font-display text-lg leading-snug tracking-tight">"{r.text}"</p>
              <div className="mt-8 flex items-center gap-3">
                <img src={r.avatar} alt={r.name} className="h-11 w-11 rounded-full object-cover grayscale" />
                <div>
                  <p className="text-sm font-medium">{r.name}</p>
                  <p className="text-xs text-muted-foreground">{r.role || "Verified Customer"}</p>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
